import fetchCommerceToolsGraphQLApi from "../fetchCommerceToolsGraphQLApi"

const query = /* GraphQL */ `
	query productIdsBySku($skus: [String!]!) {
		products(skus: $skus) {
			results {
				id
				masterData {
					current {
						masterVariant {
							sku
						}
					}
				}
			}
		}
	}
`

const fetchProductIdsBySku = async (accessToken: string, skus: string[]) => {
	const data = (await fetchCommerceToolsGraphQLApi(accessToken, query, { skus })) as {
		products: {
			results: {
				id: string
				masterData: {
					current: {
						masterVariant: {
							sku: string
						}
					}
				}
			}[]
		}
	}

	const products = data?.products?.results ?? []

	const productIdsBySku = products.reduce(
		(productIdsBySku, product) => {
			const { id, masterData } = product

			const sku = masterData?.current?.masterVariant?.sku
			return {
				...productIdsBySku,
				[sku]: id,
			}
		},
		{} as {
			[sku: string]: string
		},
	)

	return productIdsBySku
}

export default fetchProductIdsBySku
